module.exports = __webpack_public_path__ + "img/logo_cicsa.e6cce184.png";